<template>
  <v-card :elevation="$root.ele" class="mt-5">
    <v-data-table
      :search="search"
      :headers="headers"
      class="templates-table"
      :items="list"
    >
      <template v-slot:top>
        <div class="pa-4">
          <v-text-field
            hide-details=""
            label="Search"
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
          >
          </v-text-field>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex">
          <create :item="item"></create>
          <remove-icon-button
            v-if="isAdmin"
            @click="remove(item)"
          ></remove-icon-button>
        </div>
      </template>
      <template v-slot:item.updated_by="{ item }">
        {{ updated(item) }}
      </template>
      <template v-slot:item.name="{ item }">
        <div class="text-capitalize">
          {{ item.name }}
        </div>
      </template>
      <template v-slot:item.users="{ item }">
        <div class="text-capitalize">
          {{ users(item) }}
        </div>
      </template>
    </v-data-table>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import { technicianGroups } from "../../../assets/js/firebase";
import types from "../../../assets/js/types";
import RemoveIconButton from "../../buttons/RemoveIconButton.vue";
import Create from "./Create.vue";
export default {
  components: { Create, RemoveIconButton },
  data() {
    return {
      lastDoc: null,
      types: types,
      search: "",
      id: ""
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "NAME", value: "name" },
        { text: "TECHNICIANS", value: "users" },
        { text: "ACTION", value: "action" }
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text,
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true
        };
        if (value === "action") {
          doc.divider = false;
          doc.width = "100px";
        }
        list.push(doc);
      }
      return list;
    },
    list() {
      return this.$store.getters.technicianGroups;
    },
    technicians() {
      return this.$store.getters.technicians.map(item => {
        let name = item.first_name + " " + item.last_name;
        return { name: name, value: item.id };
      });
    }
  },
  methods: {
    async remove({ id }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure? you want to remove this technician group",
        onConfirm: async () => {
          try {
            vm.$root.loader = true;
            await technicianGroups.doc(id).delete();
            vm.$root.loader = false;
          } catch (error) {
            vm.$root.alert(error.message);
            vm.$root.loader = false;
          }
        }
      });
    },
    users({ users }) {
      let str = "";
      users.forEach(value => {
        let doc = this.technicians.find(item => {
          return item.value == value;
        });
        if (doc instanceof Object) str += doc.name + ", ";
      });
      if (str.endsWith(", ")) {
        str = str.trim().slice(0, -1);
      }
      return str;
    },
    openChat(item) {
      let { name, phone } = item;
      if (this.isMobile) {
        this.$router.push({
          path: `/technician-sms-view/${phone}`,
          query: {
            id: phone,
            name: name,
            phone
          }
        });
      } else {
        this.$router.push({
          path: `/technician-sms`,
          query: {
            id: phone,
            name: name,
            phone
          }
        });
      }
    },
    updated({ updated_by }) {
      let name = updated_by;
      this.list.forEach(item => {
        let { email, first_name, last_name } = item;
        if (email === updated_by) name = `${first_name} ${last_name}`;
      });
      return name;
    },
    type({ type }) {
      let name = "";
      this.types.forEach(item => {
        if (item.value === type) name = item.name;
      });
      return name;
    }
  }
};
</script>

<style lang="scss"></style>
